exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InvoiceDetalization_tooManyTransactionsMessage_3Atj {\n  margin-top: 40px;\n  margin-bottom: 20px;\n\n  font-size: 17px;\n  text-align: center;\n}\n\n.InvoiceDetalization_tooManyTransactionsTitle_1z2- {\n  margin: 0 120px 20px 120px;\n\n  display: inline-block;\n}\n\n.InvoiceDetalization_preloader_feQ1 {\n  position: static;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n", ""]);

// exports
exports.locals = {
	"tooManyTransactionsMessage": "InvoiceDetalization_tooManyTransactionsMessage_3Atj",
	"tooManyTransactionsTitle": "InvoiceDetalization_tooManyTransactionsTitle_1z2-",
	"preloader": "InvoiceDetalization_preloader_feQ1"
};